import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b1eadf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold grid-content" }, "Create Catalog", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1))
const _hoisted_3 = { class: "px-10 pt-0" }
const _hoisted_4 = { class: "pt-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-1 font-bold grid-content text-small" }, [
  /*#__PURE__*/_createTextVNode(" Name "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1))
const _hoisted_6 = { class: "pt-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-1 font-bold grid-content text-small" }, " Category ", -1))
const _hoisted_8 = { class: "pt-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-1 font-bold grid-content text-small" }, [
  /*#__PURE__*/_createTextVNode(" Product Code "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1))
const _hoisted_10 = { class: "pt-3" }
const _hoisted_11 = { class: "pt-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Variants")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Artwork Template")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mockup")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Production")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Shipping")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Material")
], -1))
const _hoisted_18 = { class: "flex items-center justify-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("  Discard ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Variants = _resolveComponent("Variants")!
  const _component_DesignTemplate = _resolveComponent("DesignTemplate")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "p-2.5 w-full create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 24 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: "create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, null, {
                            header: _withCtx(() => [
                              _hoisted_2
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_el_form, {
                                  model: _ctx.catalog,
                                  rules: _ctx.rulesCatalog,
                                  ref: "catalogForm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "name",
                                      required: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                          _hoisted_5,
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.catalog.name,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.catalog.name) = $event)),
                                            placeholder: "Enter name"
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "category"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _hoisted_7,
                                          _createVNode(_component_el_select, {
                                            class: "w-full",
                                            multiple: "",
                                            modelValue: _ctx.catalog.categories,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.catalog.categories) = $event)),
                                            placeholder: "Select category"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item._id,
                                                  label: item.title,
                                                  value: item._id,
                                                  size: 25
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "productCode",
                                      required: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                          _hoisted_9,
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.catalog.productCode,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catalog.productCode) = $event)),
                                            placeholder: "Product code"
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["model", "rules"]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_Editor, {
                                      heading: `Description`,
                                      modelValue: _ctx.catalog.description,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.catalog.description) = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_Editor, {
                                      heading: `Description 2`,
                                      modelValue: _ctx.catalog.description2,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.catalog.description2) = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_12
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Variants, {
                                onCallback: _ctx.callbackVariant,
                                onChangeCostBy: _ctx.changeCostBy,
                                colors: _ctx.catalog.colors,
                                sizes: _ctx.catalog.sizes,
                                values: _ctx.catalog.variants,
                                costBy: _ctx.costBy,
                                productCode: _ctx.catalog.productCode,
                                typeAction: "create"
                              }, null, 8, ["onCallback", "onChangeCostBy", "colors", "sizes", "values", "costBy", "productCode"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_13
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_DesignTemplate, {
                                isAccept: 
                  _ctx.isSubmit && _ctx.catalog.designs.length === 0 ? true : false
                ,
                                dataSet: _ctx.catalog.designs,
                                onCallback: _ctx.addDesign,
                                onDelDesign: _ctx.delDesign
                              }, null, 8, ["isAccept", "dataSet", "onCallback", "onDelDesign"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "pl-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { "body-style": { 'padding-top': '0px' } }, {
                    header: _withCtx(() => [
                      _hoisted_14
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_UploadImage, {
                        accept: `image/*`,
                        multiple: true,
                        title: "",
                        setData: _ctx.catalog,
                        data: _ctx.catalog.mockupGallery,
                        onCallback: _ctx.callbackMockup
                      }, null, 8, ["setData", "data", "onCallback"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_15
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.catalog.production,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.catalog.production) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_16
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.catalog.shipping,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.catalog.shipping) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_17
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.catalog.material,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.catalog.material) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_row, { class: "mt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, { onClick: _ctx.discard }, {
                    default: _withCtx(() => [
                      _hoisted_20,
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.addCatalog
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22,
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}